// @flow

import React from 'react';
import { withTranslation } from 'next-i18next';
import { TabsProvider, Tabs, TabButton } from '@starladder/ui-react';

import { ELEMENT_PRESENCE } from '@sharedConstants/mainConstants';

import UiStub from 'shared/_ui/stub/UiStub';
import UiPageHeading from 'shared/_ui/page-heading/UiPageHeading';
import UiSection from 'shared/_ui/section/UiSection';
import NewsPreviewRegular from 'shared/components/news/preview/regular/NewsPreviewRegular';
import UiLoader from 'starladder/_ui/loader/UiLoader';

import type { NewsItemType } from 'shared/logic/news/types';

import styleTournaments from 'shared/styles/modules/tournament/list.module.css';
import tabsStyle from 'shared/styles/modules/tabs/page.module.css';

type PropsType = {
  newsList: Array<NewsItemType>,
  stubTitle: string,
  locale: string,
  backgroundImg: {
    small: string,
    medium: string,
    big: string,
    large: string
  },
  tabs: Array<{
    id: number,
    value: string,
    text: string
  }>,
  styleMod: string,
  currentTabId: number,
  isLoad: boolean,
  withoutEvent: boolean,
  onTabClick: void,
  t: Function
};

const IMG_MAX_WIDTH = {
  small: '500px',
  medium: '1960px'
};

function NewsRegularBlock({
  newsList,
  stubTitle,
  backgroundImg,
  tabs,
  styleMod,
  currentTabId,
  locale,
  isLoad,
  withoutEvent,
  onTabClick,
  t
}: PropsType) {
  return (
    <TabsProvider initialValue={currentTabId}>
      <UiPageHeading title={t('common:news')} backgroundImg={backgroundImg}>
        {!ELEMENT_PRESENCE.withoutEventNewsTabs && (
          <Tabs style={tabsStyle}>
            {tabs.map((item) => (
              <TabButton value={item.id} style={tabsStyle} onClick={onTabClick} key={item.id}>
                <span className={tabsStyle.tabText}>{t(item.text)}</span>
              </TabButton>
            ))}
          </Tabs>
        )}
      </UiPageHeading>
      <UiSection styleMod={styleMod} pdMod="page">
        {newsList.length === 0 && !isLoad ? (
          <UiStub title={t(stubTitle)} />
        ) : (
          <ul className={styleTournaments.tournamentNews}>
            {newsList.map((item) => (
              <li className={styleTournaments.tournamentNewsItem} key={item.id}>
                <NewsPreviewRegular
                  title={item.title}
                  description={item.description}
                  img={item.img}
                  slug={item.slug}
                  imgMaxWidth={IMG_MAX_WIDTH}
                  isVideo={item.isVideo}
                  publishedAt={item.publishedAt}
                  isLoading={isLoad && !item.title}
                  styleMod={styleMod}
                  locale={locale}
                  withoutEvent={withoutEvent}
                />
              </li>
            ))}
          </ul>
        )}
        {isLoad && <UiLoader />}
      </UiSection>
    </TabsProvider>
  );
}

export default withTranslation('news')(NewsRegularBlock);
